import { ITriagem } from "../../../Interfaces/Geral/Email/EmailInterface";
import {
    IBlacklistEmail,
    IEmail,
    IEmailTriagem,
    IGestaoTriagem,
} from "../../../Interfaces/Geral/Triagem";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function ListarEmailsTriagemService() {
    return Service(Axios.get<Array<IEmail>>(`/home/email/listaremailstriagem`));
}

export async function ListarEmailsTriagemComFiltroService(
    filtro: ITriagem,
    idTipoCaso?: number
) {
    return Service(
        Axios.post<IGestaoTriagem>(
            `/home/email/listaremailstriagemcomfiltro?idTipoCaso=${idTipoCaso}`,
            filtro
        )
    );
}

export async function IgnorarEmailTriagemService(IdEmail: number) {
    return Service(
        Axios.put(`/home/email/ignoraremailtriagem?IdEmail=${IdEmail}`)
    );
}

export async function AdicionarEmailBlacklistService(dsEmail: string) {
    return Service(
        Axios.post(`/home/email/adicionaremailblacklist?dsEmail=${dsEmail}`)
    );
}

export async function RemoverEmailBlacklistService(idEmailBlacklist: number) {
    return Service(
        Axios.delete(
            `/home/email/removeremailblacklist?idEmailBlacklist=${idEmailBlacklist}`
        )
    );
}

export function ListarEmailBlacklistService() {
    return Service(
        Axios.get<Array<IBlacklistEmail>>(`/home/email/listaremailsblacklist`)
    );
}

export const VincularEmailTriagemService = async (email: IEmailTriagem) =>
    Service(Axios.post(`/home/email/vincularemailtriagem`, email));

export function DescartarEmailTriagemService(idsEmails: number[]) {
    return Service(Axios.post(`/home/email/descartaremailstriagem`, idsEmails));
}
export function BaixarEmailTriagemExcelService(requestBody: ITriagem) {
    return Service(
        Axios.post<Blob>(`/home/email/exportartriagemexcel`, requestBody, {
            responseType: "blob",
        })
    );
}

export function VincularClienteEmailTriagemService(
    ID_CONTA: number,
    ID_EMAIL: number,
    ID_UNIDADE: number
) {
    return Service(
        Axios.post(
            `/home/email/vincularclienteemailtriagem?ID_CONTA=${ID_CONTA}&ID_EMAIL=${ID_EMAIL}&ID_UNIDADE=${ID_UNIDADE}`
        )
    );
}

export function DesvincularClienteEmailTriagemService(ID_EMAIL: number) {
    return Service(
        Axios.delete(
            `/home/email/desvincularclienteemailtriagem?ID_EMAIL=${ID_EMAIL}`
        )
    );
}
